// Vragen die ondernemers in de regio daadwerkelijk stellen in het eerste
// gesprek. Deze lijst voedt zowel de FAQ-sectie op de home als het
// FAQPage-schema, zodat vraag en antwoord altijd gelijk zijn.

export interface FAQItem {
  question: string
  answer: string
}

export const homeFaqs: FAQItem[] = [
  {
    question: 'Wat kost een website laten maken bij Noord Digital?',
    answer:
      'Een onepager start vanaf €499. Een website met meerdere pagina\u2019s, een eigen pagina per dienst en een aanvraagformulier ligt daarboven, afhankelijk van hoeveel er op moet. Je krijgt altijd een vaste prijs per onderdeel, zodat je vooraf weet waar je aan toe bent. Hosting en onderhoud lopen los als abonnement.',
  },
  {
    question: 'Hoe lang duurt het voordat mijn website online staat?',
    answer:
      'Een onepager staat doorgaans binnen twee tot drie weken live. Een grotere site met een pagina per dienst duurt zes tot acht weken. De doorlooptijd hangt vooral af van hoe snel teksten en foto\u2019s er zijn, dus daar helpen we bij.',
  },
  {
    question: 'Hoe lang duurt het voordat ik beter gevonden word in Google?',
    answer:
      'Voor lokale zoekopdrachten zie je meestal binnen twee tot drie maanden beweging, omdat de concurrentie in Noord-Holland Noord op veel termen beperkt is. Voor bredere en drukkere zoekwoorden reken je op zes maanden of langer. Wij beloven geen posities, want die bepaalt Google, wel dat we bouwen op de zoekvragen waar echt vraag achter zit.',
  },
  {
    question: 'Werken jullie ook voor bedrijven buiten Noord-Holland Noord?',
    answer:
      'Ja, maar onze kracht zit in de regio. We kennen het zoekgedrag van klanten in Dijk en Waard, Alkmaar, Heerhugowaard, Schagen en omstreken, en we kunnen langskomen. Zit je verder weg? Dan werken we op afstand en gaat het net zo goed.',
  },
  {
    question: 'Kan ik mijn website daarna zelf aanpassen?',
    answer:
      'Ja. We bouwen in WordPress, zodat je teksten, foto\u2019s en prijzen zelf kunt bijwerken zonder technische kennis. Bij de oplevering krijg je uitleg en je kunt daarna altijd bellen met een vraag. Ook je huisstijl leveren we aanpasbaar op, als Figma-document.',
  },
  {
    question: 'Moet ik alles bij jullie afnemen?',
    answer:
      'Nee. De meeste ondernemers beginnen bij een website of bij hun vormgeving en breiden pas uit als daar resultaat uit komt. Vormgeving kan ook los, zonder website bij ons. Neem je een website en hosting bij ons af, dan krijg je korting op vormgeving.',
  },
  {
    question: 'Wat gebeurt er na oplevering?',
    answer:
      'Wij verzorgen de hosting, dagelijkse back-ups, updates en monitoring. Je hebt een vast aanspreekpunt en geen wachtrij. Kleine wijzigingen pakken we op binnen een paar werkdagen, bij een site die offline gaat reageren we binnen één werkdag.',
  },
]
